import { type MetaFunction } from '@remix-run/node'
import HeroMock from '#app/components/mock-test/hero-mock.js'
import TestHighlights from '#app/components/mock-test/test-highlights.js'

export const meta: MetaFunction = () => [
	{ title: "marky | India's most advanced OMR evaluation system" },
]

export default function Index() {
	return (
		<main className="grid bg-background">
			<HeroMock />
			<TestHighlights />
		</main>
	)
}
